export default __webpack_public_path__ + "static/media/ok.29ea1c3a.svg";